import React from 'react'
import PropTypes from 'prop-types';
import { FormControlLabel, Checkbox } from '@mui/material';
import { trakrefFontFamily } from "../../../utils";
import { trakrefBlue } from "../../../color_utils";

const CheckBox = ({
    label,
    checked,
    onChange,
    labelPlacement,
    labelStyle,
    disabled,
    indeterminate,
}) => (
    <FormControlLabel
        label={label}
        labelPlacement={labelPlacement}
        disabled={disabled}
        sx={{
            '& .MuiFormControlLabel-label': { fontFamily: trakrefFontFamily },
            ...labelStyle
        }}
        control={
            <Checkbox
                checked={checked}
                onChange={onChange}
                sx={{
                    '&.Mui-checked': { color: trakrefBlue },
                    '&.MuiCheckbox-indeterminate': { color: trakrefBlue }
                }}
                indeterminate={indeterminate}
            />
        }
    />
);

CheckBox.propTypes = {
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    checked: PropTypes.bool,
    labelPlacement: PropTypes.string,
    labelStyle: PropTypes.object,
    disabled: PropTypes.bool,
    indeterminate: PropTypes.bool,
};

CheckBox.defaultProps = {
    label: "",
    checked: false,
    labelPlacement: "end",
    labelStyle: {},
    disabled: false,
    indeterminate: false,
};

export default CheckBox;
